import { render, staticRenderFns } from "./text-masker.vue?vue&type=template&id=65f0ae8f";
import script from "./text-masker.vue?vue&type=script&lang=js";
export * from "./text-masker.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;